import script from "./SurveyStart.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyStart.vue?vue&type=script&setup=true&lang=js"

import "./SurveyStart.vue?vue&type=style&index=0&id=77354996&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77354996"]])

export default __exports__